/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import { format, isValid } from "date-fns";
import Grid from "@mui/material/Grid";

import {
  Input,
  SelectAutocomplete,
  AutoSaveField as Field,
  DatePicker,
  AsyncSelectAutoComplete
} from "../../../../../../components/Form";
import { DATE_FORMAT } from "../../../../../../constants";
import { Label } from "./styled";

export const SignatoryUAE = ({
  uaeClearingBankArr,
  uaeTakeOverBankArr,
  getDatalistSearch,
  basePath,
  bankIndex
}) => {
  const changeDateProspectHandler = (_, value, path) =>
    isValid(value) && { [path]: format(value, DATE_FORMAT) };
  return (
    <>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].loanAvailedDate`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].loanAvailedDate`}
          label="Date Loan facility availed"
          placeholder="Date Loan facility availed"
          component={DatePicker}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
          changeProspect={changeDateProspectHandler}
          maxDate={new Date()}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].emiPaid`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].emiPaid`}
          label="EMI paid/ tenure paid"
          placeholder="EMI paid/ tenure paid"
          component={Input}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].emiAmount`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].emiAmount`}
          label="EMI amount"
          placeholder="EMI amount"
          component={Input}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].emiClearing`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].emiClearing`}
          label="EMI Clearing"
          placeholder="EMI Clearing"
          component={DatePicker}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
          changeProspect={changeDateProspectHandler}
          disableFuture={false}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].clearingBank`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].clearingBank`}
          label="Clearing Bank"
          placeholder="Clearing Bank"
          component={AsyncSelectAutoComplete}
          getDatalistSearch={getDatalistSearch}
          codeType="UAEB"
          defaultValue={uaeClearingBankArr[bankIndex]}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].takeOverBank`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].takeOverBank`}
          label="Take Over Bank"
          placeholder="Take Over Bank"
          component={AsyncSelectAutoComplete}
          getDatalistSearch={getDatalistSearch}
          codeType="UAEB"
          defaultValue={uaeTakeOverBankArr[bankIndex]}
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].outstandingExposure`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].outstandingExposure`}
          label="Outstanding or Clean Exposure"
          placeholder="Outstanding or Clean Exposure"
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
          component={Input}
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].facilityLetterProvided`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].facilityLetterProvided`}
          label="Facility Letter for all trade finance and business documents provided"
          placeholder="Facility Letter for all trade finance and business documents provided"
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
          component={SelectAutocomplete}
          datalistId="flagWithNa"
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].howPreviousRBLUtilised`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].howPreviousRBLUtilised`}
          label="Comment on how was the previous RBL utilised"
          placeholder="Comment on how was the previous RBL utilised"
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
          component={Input}
          multiline
          rows="4"
        />
      </Grid>{" "}
      <Grid item sm={12} xs={12}>
        <Label>
          Comment on how was Other Bank business loans utilised since previous RBL or 12 months(
          whichever was most recent)
        </Label>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].howOtherBankLoanUtilised`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].howOtherBankLoanUtilised`}
          // label=""
          placeholder="Comment on how was Other Bank business loans utilised since previous RBL or 12 months( whichever was most recent)"
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
          component={Input}
          multiline
          rows="4"
        />
      </Grid>
    </>
  );
};

SignatoryUAE.propTypes = {
  /**
   * Base path for the Redux store path
   */
  basePath: PropTypes.string.isRequired,

  /**
   * Index of the bank in the banking relationships array
   */
  bankIndex: PropTypes.number.isRequired,

  /**
   * Array of UAE clearing bank selected objects
   */
  uaeClearingBankArr: PropTypes.array,

  /**
   * Array of UAE take over bank selected objects
   */
  uaeTakeOverBankArr: PropTypes.array,

  /**
   * Function to search datalist by code type
   */
  getDatalistSearch: PropTypes.func.isRequired
};
